import DropdownNotification, {
  type NotificationProps,
} from "./DropdownNotification";
import { useRef } from "react";
import { useClickOutside } from "~/hooks/useClickOutside";
import kriptoEllipse from "../../../assets/kriptoEllipse.svg";
import BankIcon from "~/components/icons/BankIcon";
import CryptoIcon from "~/components/icons/CryptoIcon";
import RealestateIcon from "~/components/icons/RealestateIcon";
import ShareIcon from "~/components/icons/ShareIcon";
import DebtIcon from "~/components/icons/DebtIcon";
import OtherIcon from "~/components/icons/OtherIcon";
import PensionIcon from "~/components/icons/PensionIcon";
import { Forms } from "~/utils/products";
import RSUIcon from "~/components/icons/RSUIcon";
import AIIcon from "~/components/icons/AIIcon";
import type { Affiliate } from "~/types/global.types";

type Props = {
  isOpen: boolean;
  notifications: NotificationProps[];
  mobileStyle?: boolean;
  onAssestPage?: React.CSSProperties["left"];
  closeDropdown: () => void;
  containerRef: HTMLDivElement | null;
  updateNotifications: (productId: string, insightId: string) => void;
  portfolioId?: number;
};

const NotificationsList = ({
  isOpen,
  notifications,
  mobileStyle,
  onAssestPage,
  closeDropdown,
  containerRef,
  updateNotifications,
  portfolioId,
}: Props) => {
  const affiliateDataStr = window.localStorage.getItem("affiliateData");
  const affiliateData =
    affiliateDataStr && affiliateDataStr !== "undefined"
      ? (JSON.parse(affiliateDataStr) as Affiliate)
      : undefined;

  const notificationsContainerRef = useRef<HTMLUListElement>(null);
  useClickOutside(
    [notificationsContainerRef.current, containerRef],
    closeDropdown,
    isOpen && notifications.length > 0
  );
  notifications.sort((a, b) =>
    (a.shouldNotify || 0) > (b.shouldNotify || 0) ? -1 : 1
  );

  return (
    <div
      className={`
           ${
             mobileStyle
               ? `absolute bottom-12 left-1/2 flex w-[100vw] translate-x-[-45%] items-center justify-center text-center`
               : `absolute ${
                   onAssestPage
                     ? `top-[145%] ${onAssestPage}`
                     : "start-0 top-[145%]"
                 }  `
           }
         `}
    >
      <ul
        dir="ltr"
        className={`z-10 flex h-fit max-h-[300px] rounded-md ${
          mobileStyle ? "w-[70vw]" : "w-[300px]"
        } flex-col justify-start overflow-y-auto ${
          isOpen &&
          " scale-100 transform border-menu bg-surface opacity-100 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        }`}
        ref={notificationsContainerRef}
      >
        {isOpen && (
          <>
            {notifications.map((notification, index) => (
              <DropdownNotification
                key={`insight-${index}`}
                to={notification.to}
                closeDropdown={closeDropdown}
                id={notification.id}
                productId={notification.productId}
                updateNotifications={updateNotifications}
                portfolioId={portfolioId}
              >
                <div
                  className={
                    "flex flex-col justify-end text-sm text-gray-700 hover:bg-gray-200 " +
                    (notification.shouldNotify ? "bg-background" : "")
                  }
                >
                  <div className="justify-right flex items-center p-2">
                    {/* {notification.category && ( */}
                    <div className="me-2 h-[43px] w-[43px] shrink-0 rounded-full border-[3px] border-solid border-white text-secondary shadow-lg">
                      <div className="m-[3px]">
                        {getImgbyCategory(
                          parseInt(notification.id) > 10000
                            ? "ai"
                            : notification.category || "",
                          "30px",
                          affiliateData
                        )}
                      </div>
                    </div>
                    {/* )} */}
                    <span
                      className={
                        notification.shouldNotify ? "font-semibold" : ""
                      }
                    >
                      {notification.notification}
                    </span>
                    {notification.shouldNotify && (
                      <img
                        className="me-2 px-1"
                        src={kriptoEllipse}
                        alt=""
                      ></img>
                    )}
                  </div>
                </div>
                <hr className="border-t-[1px] border-gray-300 bg-secondary" />
              </DropdownNotification>
            ))}
          </>
        )}
      </ul>
    </div>
  );
};
export default NotificationsList;

export function getImgbyCategory(
  category: string,
  size: string = "30px",
  affiliateData?: any
): JSX.Element | null {
  // Handle AI insights with planner logo
  if (category === "ai" && affiliateData?.logo) {
    return (
      <img
        src={affiliateData.logo}
        alt="planner logo"
        style={{
          height: size,
          width: size,
          objectFit: "contain",
          borderRadius: "50%",
        }}
      />
    );
  }

  switch (category) {
    case Forms.BANK:
      return BankIcon({ height: size, width: size });
    case Forms.BANK2:
      return BankIcon({ height: size, width: size });
    case Forms.CRYPTO:
      return CryptoIcon({ height: size, width: size });
    case Forms.REALESTATE:
      return RealestateIcon({ height: size, width: size });
    case Forms.SHARE:
      return ShareIcon({ height: size, width: size });
    case Forms.DEBT:
      return DebtIcon({ height: size, width: size });
    case Forms.OTHER:
      return OtherIcon({ height: size, width: size });
    case Forms.PENSION:
      return PensionIcon({ height: size, width: size });
    case Forms.RSU:
      return RSUIcon({ height: size, width: size });
    case "ai":
      // Fallback to AIIcon if no affiliate logo
      return AIIcon({ height: size, width: size });
    default:
      return OtherIcon({ height: size, width: size });
  }
}
